import { useEffect } from 'react';

/**
 * Hook for bfcache-friendly cleanup
 * Properly handles cleanup without preventing back/forward cache restoration
 * 
 * Uses 'pagehide' event instead of 'unload' to avoid blocking bfcache
 * See: https://web.dev/bfcache/#beware-of-unload-handlers
 */
export const useBfcacheCleanup = () => {
  useEffect(() => {
    // Use pagehide instead of unload/beforeunload - it doesn't block bfcache
    const handlePageHide = () => {
      // Close any WebSocket connections if they exist
      if (typeof window !== 'undefined' && (window as any).__websockets) {
        const websockets = (window as any).__websockets;
        Object.values(websockets).forEach((ws: any) => {
          try {
            if (ws && ws.close) {
              ws.close(1000, 'Page unload for bfcache');
            }
          } catch (e) {
            // Ignore cleanup errors
          }
        });
      }
    };

    // Don't use addEventListener for unload/beforeunload - it blocks bfcache
    // Only use pagehide with preventDefault = false (default)
    window.addEventListener('pagehide', handlePageHide);

    return () => {
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, []);
};
